module.exports = __webpack_public_path__ + "img/jingfu-e-licence.bfbdd439.jpg";